// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Image, Text } from '@locus-taxy/neo-ui';

import emptyRowsSvg from 'common/img/empty-orders.svg';

const NoRows = (): React.Node => {
    const { t } = useTranslation();

    return (
        <Flex
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            height="100%"
        >
            <Image src={emptyRowsSvg} />
            <Text fontSize={3} mt={3}>
                {t('noRowsFound')}
            </Text>
        </Flex>
    );
};

export default NoRows;
